import React from "react";
import { Navigate } from "react-router-dom";
import { getPermissions, getToken } from "../context/AuthContext";

interface PermissionRouteProps {
  children: React.ReactNode;
  permission: string;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({
  children,
  permission,
}) => {
  const isAuthenticated = getToken();
  const permissions = getPermissions();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!permissions.includes(permission)) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
};

export default PermissionRoute;
